import { ApplyForm } from '../components/ApplyForm/ApplyFormNew'

export default ApplyForm
